import React from "react";
import "./ContactUsPage.css";

const ContactUsPage = () => {

    return (
        <div className="contact-us-content">
            <div className="row">
                <iframe 
                    className="contact-us-map"
                    title="office-location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8149907898687!2d103.84392207458654!3d1.284966998702823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190b6675f101%3A0x297e9285be7fc72c!2sFook%20Hai%20Building!5e0!3m2!1sen!2ssg!4v1781541261625!5m2!1sen!2ssg"
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"
                />
            </div>

            <div className="row">
                <div className="contact-us-detail">
                    <div className="contact-us-info">
                        <h3 className="title">ACE ARCHITECTS & ASSOCIATES</h3>
                        <div className="info-section">
                            <i class="bi bi-geo-fill icon text-danger"></i>
                            <p>150 South Bridge Rd, #05-02B Fook Hai Building, S 058727</p>
                        </div>
                        <div className="info-section">
                            <i class="bi bi-envelope-fill text-primary"></i>
                            <p>ace@acearch.com.sg</p>
                        </div>
                        <div className="info-section">
                            <i class="bi bi-telephone-fill text-success"></i>
                            <p>62233730</p>
                        </div>
                    </div>
                </div>
            </div>
            
            
        </div>
    )
}

export default ContactUsPage;